import { type CreateDelegacionInmobiliariaModel, type DireccionModel } from "@api/api";

export class CreateDelegacionInmobiliaria implements CreateDelegacionInmobiliariaModel
{
    IdEmpresaInmobiliaria: string = '';
    Nombre: string = '';
    Descripcion: string = '';
    Telefono: string = '';
    Web: string = '';
    Email: string = '';
    Direccion: DireccionModel = {
        CodigoPostal: null,
        Provincia: null,
        Municipio: null,
        TipoVia: null,
        NombreVia: null,
        Numero: null,
        Escalera: null,
        Piso: null,
        Puerta: null
      };

      constructor(data?: Partial<CreateDelegacionInmobiliaria>) {
        Object.assign(this, data);
      }
    Coordinadores: string[] = [];
}